module.exports = __webpack_public_path__ + "img/20-notas-selo.41b43bfd.svg";